import React from 'react';

const SolveResult = ({ solveResult, algorithms, locations }) => {
  if (!solveResult) return null;
  
  // Check if capacity constraint mode is enabled
  const isCapacityConstrained = solveResult.trips_needed && solveResult.trips_needed > 0;
  
  return (
    <div className="solve-result">
      <h5>Solve Result</h5>
      <div className="result-details">
        <p><strong>Mode:</strong> {isCapacityConstrained ? 'Capacity Constraint Enabled' : 'Standard Mode'}</p>
        <p><strong>Total Time:</strong> {solveResult.totalTime ? `${solveResult.totalTime.toFixed(1)} hours` : 'N/A'}</p>
        {isCapacityConstrained && solveResult.demand && (
          <p><strong>Total Demand:</strong> {solveResult.demand} units</p>
        )}
        <p><strong>Algorithm Used:</strong> {algorithms[solveResult.algorithm]?.name || solveResult.algorithm}</p>
        
        {/* Path Sequence - moved here */}
        <div className="path-sequence-section">
          <p><strong>Path Sequence:</strong></p>
          <div className="path-sequence">
            {solveResult.path.map((id, index) => {
              const loc = locations.find(l => l.id === id);
              return (
                <div key={`${id}-${index}`} className="path-point">
                  <span className="path-name">{loc ? loc.name : id}</span>
                  {index < solveResult.path.length - 1 && <span className="path-arrow">→</span>}
                </div>
              );
            })}
          </div>
        </div>
        
        {/* Capacity constraint results */}
        {isCapacityConstrained && (
          <div className="capacity-constraint-results">
            <div className="capacity-divider"></div>
            <p className="capacity-header"><strong>Capacity Analysis:</strong></p>
            
            {/* Display all route segments */}
            {solveResult.vehiclePaths && solveResult.vehiclePaths.length > 0 && solveResult.vehiclePaths[0].segments && (
              <div className="route-segments-info">
                {solveResult.vehiclePaths[0].segments.map((segment, idx) => {
                  const tripsNeeded = Math.ceil(solveResult.demand / segment.capacity);
                  const segmentTotalTime = segment.duration * tripsNeeded;
                  const singleTripCapacity = segment.capacity;
                  
                  return (
                    <div key={idx} className="segment-card">
                      <div className="segment-title">
                        <span className="segment-route">{segment.from} → {segment.to}</span>
                        <span className="transport-mode-badge">{segment.transport_mode}</span>
                      </div>
                      
                      <div className="segment-info-grid">
                        <div className="info-item">
                          <span className="info-label">Single Trip Time:</span>
                          <span className="info-value">{segment.duration}h</span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">Trips Needed:</span>
                          <span className="info-value">{tripsNeeded}</span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">Segment Total Time:</span>
                          <span className="info-value-highlight">{segmentTotalTime}h</span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">Capacity per Trip:</span>
                          <span className="info-value">{singleTripCapacity} units</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
        
        {solveResult.vehiclePaths && solveResult.vehiclePaths.length > 1 ? (
          // Multi-vehicle path display
          <div className="vehicle-paths-result">
            <p><strong>Vehicle Paths:</strong></p>
            {solveResult.vehiclePaths.map((vehicle, index) => (
              <div key={vehicle.id || index} className="vehicle-path-item">
                <div className="vehicle-path-header" style={{background: vehicle.color || '#2196F3'}}>
                  <span>Vehicle {index + 1}</span>
                  <span>{vehicle.distance?.toFixed(2) || 'Unknown'} km</span>
                </div>
                <div className="path-sequence">
                  {vehicle.path.map((point, pointIndex) => {
                    const loc = typeof point === 'string' 
                      ? locations.find(l => l.id === point)
                      : (point.id 
                        ? locations.find(l => l.id === point.id) 
                        : point);
                    const pointName = loc ? (loc.name || loc.id) : (point.id || point);
                    return (
                      <div key={`${pointName}-${pointIndex}`} className="path-point">
                        <span className="path-name">{pointName}</span>
                        {pointIndex < vehicle.path.length - 1 && <span className="path-arrow">→</span>}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SolveResult; 